import React from 'react';
import {useGetSelfEmployeeQuery} from "../../store/api/EmployeeApi";
import LoadingBlock from "../../components/loader/LoadingBlock";
import ErrorBadGateway from "../../components/error/ErrorBadGateway";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const PermissionProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {isLoading, isError} = useGetSelfEmployeeQuery()

    if (isLoading) return <LoadingBlock/>
    if (isError) return <ErrorBadGateway/>

    return (
        <>
            {children}
        </>
    );
}

export default PermissionProvider;